import { LoginMethod } from "@/types/auth";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface FormData {
  name: string;
  loginMethod: LoginMethod;
  email: string;
  phone: string;
  aadhar: string;
  referralCode: string;
  password: string;
  confirmPassword: string;
}

interface NameStepProps {
  control: Control<FormData>;
}

export function NameStep({ control }: NameStepProps) {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <div className="mb-4">
        <label
          className="block font-semibold mb-3 text-primary dark:text-primary text-base tracking-wide"
          htmlFor="name"
        >
          {t("auth.registration.name") || "नाम"}
        </label>
        <div className="relative">
          <Controller
            name="name"
            control={control}
            rules={{
              required:
                t("auth.registration.nameRequired") || "Name is required",
              minLength: {
                value: 2,
                message:
                  t("auth.registration.nameMinLength") ||
                  "Name must be at least 2 characters",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <>
                <input
                  {...field}
                  id="name"
                  type="text"
                  className={`w-full px-3 py-3 border-2 border-[var(--border-light)] rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary text-center text-sm font-medium transition-all duration-300 bg-[var(--bg-surface)] text-[var(--text-primary)] ${
                    error
                      ? "border-red-400 focus:border-red-400 focus:ring-red-100"
                      : "border-[var(--border-light)] hover:border-[var(--border-medium)]"
                  }`}
                  autoFocus
                  placeholder={
                    t("auth.registration.namePlaceholder") ||
                    "अपना नाम दर्ज करें"
                  }
                />
                {field.value && (
                  <div className="absolute right-3 top-1/2 -translate-y-1/2">
                    <svg
                      className="w-4 h-4 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                )}
                {error && (
                  <div className="text-red-500 text-xs mt-1 flex items-center justify-center gap-1">
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {error.message}
                  </div>
                )}
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
}
